export default {
  auditsGrid: {
    data: [],
    total: 0
  }
}
